import { render, staticRenderFns } from "./CreateNotification.vue?vue&type=template&id=56c9c590&scoped=true&"
import script from "./CreateNotification.vue?vue&type=script&lang=js&"
export * from "./CreateNotification.vue?vue&type=script&lang=js&"
import style0 from "./CreateNotification.vue?vue&type=style&index=0&id=56c9c590&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c9c590",
  null
  
)

export default component.exports